export const SHOW_SNACKBARConst = 'SHOW_SNACKBAR'
export const HIDE_SNACKBARConst = 'HIDE_SNACKBAR'
